import { Cohort } from '@afterpaytouch/portal-api'
import { Route } from '../../../config/router'
import { OtpLoginRouteAndTriggerResult, BiometricsCheckTrigger } from '../../../model'
import { InitialiseLookup } from '../lookupMerger'
import { InitialiseNextRoute } from './types'

interface AuthRouteParams {
  existing: boolean
  passwordExists: boolean
  cohort: Cohort
  trustedSession: boolean
  isBiometricsEligible: boolean
  otpTrigger: OtpLoginRouteAndTriggerResult
  lookup: InitialiseLookup
}

export const determineAuthRoute = (params: AuthRouteParams): InitialiseNextRoute => {
  const { existing, passwordExists, cohort, trustedSession, isBiometricsEligible, otpTrigger, lookup } = params

  if (existing && passwordExists) {
    const primaryLoginMethodRoute = otpTrigger(trustedSession, isBiometricsEligible)
    return { route: primaryLoginMethodRoute, lookup }
  }

  if (existing) {
    return { route: Route.ENTER_EMAIL, lookup }
  }

  // For non-existing users with mobile lookup success
  const primaryLoginMethodRoute = otpTrigger(trustedSession, isBiometricsEligible)
  return { route: primaryLoginMethodRoute, lookup }
}

interface BiometricCheckParams {
  biometricCheckTrigger: BiometricsCheckTrigger
  isBiometricEligiblePayload: any
  cohort: Cohort
  isNewAccount: boolean
  email: string
  mobileNumber: string | null
}

export const checkBiometricEligibility = async (params: BiometricCheckParams): Promise<boolean> => {
  const { biometricCheckTrigger, isBiometricEligiblePayload, cohort, isNewAccount, email, mobileNumber } = params

  return await biometricCheckTrigger(
    {
      ...isBiometricEligiblePayload,
      isCashOnlyCohort: cohort === Cohort.CashOnly,
    },
    isNewAccount,
    email,
    mobileNumber ?? undefined
  )
}
